module.exports = __webpack_public_path__ + "img/tower_udnie.bfbdc849.jpg";